import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import ModalComponent from '../../../components/modal/ModalComponent';

interface Props {
  open: boolean;
  close: () => void;
  loading: boolean;
  confirmDelete: () => void;
  formName: string | undefined;
}

const DeleteFormModal: FC<Props> = ({ open, close, confirmDelete, formName, loading }: Props) => {
  const intl = useIntl();

  return (
    <ModalComponent
      closeSettings={close}
      buttons={[
        {
          text: intl.formatMessage({ id: 'cancel' }),
          buttonVariant: 'secondary',
          onClick: close,
        },
        {
          text: intl.formatMessage({ id: 'delete' }),
          loading: loading,
          buttonVariant: 'danger',
          onClick: confirmDelete,
        },
      ]}
      show={open}
      modalHeading={intl.formatMessage({
        id: 'formList.deleteModal.deleteModalHeader',
      })}
      modalSize="lg"
    >
      <div className="d-flex justify-content-center flex-column">
        <label className="modal-label">
          <b>
            {intl.formatMessage({ id: 'formList.deleteModal.deleteConfirmation' })}
            &nbsp;&lsquo;{formName}&lsquo;
          </b>
        </label>
      </div>
    </ModalComponent>
  );
};

export default DeleteFormModal;
